import gql from 'graphql-tag';

const UPDATE_SALESFORCE_OPPORTUNITY_FIELDS = gql`
  mutation UpdateSalesforceOpportunityFields(
    $salesforceOpportunityId: String!
    $opportunity: JSON!
  ) {
    updateSalesforceOpportunityFields(
      salesforceOpportunityId: $salesforceOpportunityId
      opportunity: $opportunity
    )
  }
`;

export default UPDATE_SALESFORCE_OPPORTUNITY_FIELDS;
